// extracted by mini-css-extract-plugin
export default {"content":"content__FhgUE","app-bar":"app-bar__o7Ehg","left":"left__q6JiY","right":"right__wtYCz","icon":"icon__+a0Ii","title":"title__sLiDW","back-icon":"back-icon__SsfZA"};